import type { HttpTransport } from "@common/api/transport";
import type { CropSchedule } from "@common/types/CropSchedule";

export type FetchCropSchedulesParams = {
  startDate: string;
  endDate: string;
  excludeHidden?: boolean;
};

export const createCropSchedulesApi = (http: HttpTransport) => ({
  destroyCropSchedule: (id: number) => http.del(`/api/crop_schedules/${id}`, {}),

  fetchCropSchedules: ({ endDate, excludeHidden, startDate }: FetchCropSchedulesParams) =>
    http.get<{ cropSchedules: CropSchedule[] }>(`/api/crop_schedules`, {
      queryParams: { endDate, excludeHidden, startDate }
    }),

  toggleCropSchedule: ({ id, visible }: { id: number; visible: boolean }) =>
    http.patch(`/api/crop_schedules/${id}`, { visible })
});
